import React from 'react';
import shieldLockIcon from '../../../../public/assets/shield-lock.svg';

const ShieldLockIcon: React.FC<{ height: number }> = ({ height }) => (
  <img src={shieldLockIcon} height={height} alt="icon" data-testid="shield-icon" />
);

export default ShieldLockIcon;
